import { Controller } from "@hotwired/stimulus";

declare var $: any;

export default class extends Controller {
  static targets = ["select"];
  declare selectTarget: HTMLSelectElement;

  connect() {
    $(this.selectTarget).multipleSelect({
      allSelected: true,
      selectAll: true,
      formatAllSelected: () => 'All',
      formatSelectAll: () => 'Select All / None',
      maxHeight: '600',
      placeholder: 'State'
    });
  }
}
